// extracted by mini-css-extract-plugin
module.exports = {"verified":"AV8CMDgZvK2H6CLbF706","details":"cjGOMCQuacDWjP77lLW0","icon":"UOwid7t1voGgX6bJSoep"};